import React, { useEffect } from 'react';
import confetti from 'canvas-confetti';
import { Trophy } from 'lucide-react';

const COLORS = ['#C8A45C', '#E8D4A0', '#FFD700', '#FFF8F0', '#1A2332'];

export const fireConfettiAt = (el) => {
  const r = el?.getBoundingClientRect();
  const origin = r
    ? { x: (r.left + r.width / 2) / window.innerWidth, y: (r.top + r.height / 2) / window.innerHeight }
    : { x: 0.5, y: 0.6 };
  confetti({ particleCount: 90, spread: 75, startVelocity: 38, scalar: 1.05, origin, colors: COLORS, zIndex: 5600, disableForReducedMotion: true });
};

export const fireFireworks = (duration = 4000) => {
  const end = Date.now() + duration;
  const rand = (min, max) => Math.random() * (max - min) + min;
  const timer = setInterval(() => {
    if (Date.now() > end) return clearInterval(timer);
    const base = { startVelocity: 32, spread: 360, ticks: 70, zIndex: 5600, colors: COLORS, disableForReducedMotion: true };
    confetti({ ...base, particleCount: 55, origin: { x: rand(0.1, 0.4), y: rand(0.15, 0.5) } });
    confetti({ ...base, particleCount: 55, origin: { x: rand(0.6, 0.9), y: rand(0.15, 0.5) } });
  }, 280);
  return () => clearInterval(timer);
};

export const CelebrationOverlay = ({ title, onClose }) => {
  useEffect(() => {
    const t = setTimeout(onClose, 5000);
    return () => clearTimeout(t);
  }, [onClose]);

  return (
    <div className="celebration-overlay" onClick={onClose} data-testid="course-complete-celebration">
      <div className="celebration-card">
        <div className="celebration-icon"><Trophy size={34} /></div>
        <h3>Projekt abgeschlossen!</h3>
        <p className="celebration-title">{title}</p>
        <p className="celebration-sub">Alle Lektionen erledigt – stark gemacht!</p>
      </div>
    </div>
  );
};
